import React from 'react'
import styles from './styles.module.scss'
import { decode } from 'html-entities/lib/index'
import config from 'config'
import GroupMixrPill from '../GroupMixrPill'
import AnchorLink from '../AnchorLink'

function MixrGroupListItem({
  id,
  picture,
  title,
  type,
  isCommon,
  className,
  titleCSS,
  lastRef,
  groupRole,
  isPastMixr,
  isLoggedUser,
  renderCustomAction = null,
  disableRedirection = false,
  groupType = 'interest'
}) {
  const hasDot = isCommon === 1 && !isLoggedUser
  let dotStyle = ''
  if (hasDot) {
    if (type === 'group') {
      if (groupRole === 'organizer' || groupRole === 'co-organizer') {
        dotStyle = 'yellow'
      } else if (groupRole === 'member') {
        dotStyle = 'purple'
      }
    } else if (type == 'mixr') {
      if (isPastMixr) {
        dotStyle = 'gray'
      } else {
        dotStyle = 'pink'
      }
    }
  }

  const handleClick = (e) => {
    if (disableRedirection) {
      e.preventDefault()
    }
  }

  return (
    <div className={`${styles.groupsMixrsContent} ${className}`} key={id} ref={lastRef}>
      {hasDot && <div className={`${styles.dot} ${styles[dotStyle]}`}></div>}
      <GroupMixrPill
        groupType={groupType}
        type={type}
        picture={picture}
        size='small'
        {...(groupType === 'expertise' ? { iconName: 'star-solid' } : '')}
      />
      <AnchorLink
        handleClick={handleClick}
        path={`/0/home/${type == 'group' ? 'group' : 'event'}/${id}`}
        className={`${styles.title} ${titleCSS}`}>
        {decode(title)}
      </AnchorLink>
      {renderCustomAction && renderCustomAction()}
    </div>
  )
}

export default MixrGroupListItem
